export const AccessibilityIcon = ({
  width = 44,
  height = 44,
  className = "",
}: {
  width?: number;
  height?: number;
  className?: string;
}) => {
  return (
    <img
      src="https://cdn.userway.org/widgetapp/images/body_bl.svg"
      alt="Accessibility Icon"
      width={width}
      height={height}
      className={className}
    />
  );
};
